import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {Note} from "../model/note";

@Component({
    selector: 'note-confirm-dialog',
    templateUrl: './noteConfirmDialog.component.html',
    styleUrls: ['./noteConfirmDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NoteConfirmDialogComponent {
    action: string;
    noteForm: FormGroup;
    dialogTitle: string;
    note: Note;

    constructor(
        public matDialogRef: MatDialogRef<NoteConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.note = _data.note;
    }
}
